// extracted by mini-css-extract-plugin
export default {"root":"SignInExport_root__O47cK","text":"SignInExport_text__HudtP","settingBtn":"SignInExport_settingBtn__G8kFP","button":"SignInExport_button__gc8LH"};